import React, { useState, useEffect } from "react";
import { Button } from "@appkit4/react-components/button";
import { Accordion, AccordionItem } from "@appkit4/react-components/accordion";
import GeneralInformation from "./GeneralInformation";
import CoporateAddress from "./CoporateAddress";
import VendorInformation from "./VendorInformation";
import VendorContactInformation from "./VendorContactInformation";
import AssessmentRequirements from "./AssessmentRequirements";
import InternalContacts from "./InternalContacts";
import Questionnaire from "./Questionnaire";
import AddMoreSpocs from "./AddMoreSpocs";
import "../../../styles/businessUser.css";
import { Formik } from "formik";
import * as Yup from "yup";
import "../../../styles/thirdparty.css";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";

function VendorManagement(props) {
  const [ActiveAccordions, setActiveAccordions] = useState(["1"]);
  const [openedAccordions, setOpenedAccordions] = useState(false);
  const [classification, setClassification] = useState([]);
  const [status, setStatus] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [subDepart, setSubDepart] = useState([]);
  const [requestedBy, setRequestedBy] = useState([]);
  const [criticality, setCriticality] = useState([]);
  const [criticalityValue, setCriticalityValue] = useState("");
  const [category, setCategory] = useState([]);
  const [emails, setEmails] = useState([]);
  const [assessmentTypes, setAssessmentTypes] = useState([]);
  const [assessmentValue, setAssessmentValue] = useState([]);
  const [frequency, setFrequency] = useState([]);
  const [recurrence, setRecurrence] = useState([]);
  const [draftValue, setDraftValue] = useState("");
  const [questions, setQuestions] = useState([]);
  const [loader, setLoader] = useState(true);
  const [save, setSave] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [spocFlag, setSpocFlag] = useState(false);
  const [selectFieldsDisabled, setSelectFieldsDisabled] = useState(false);

  const [additionalSpoc, setAdditionalSpoc] = useState({
    additionalSpocData: [{
      firstNameAdditional: "",
      lastNameAdditional: "",
      businessDesignationAdditional: "",
      emailAdditional: "",
      phoneNumberAdditional: ""
    }]
  });
  const { sendRequest: emailRoleAPI } = useHttp();
  const { sendRequest: getAllVendorList } = useHttp();
  const { sendRequest: getAllBusinessUnitList } = useHttp();
  const { sendRequest: getAllSubBusinessUnitList } = useHttp();
  const { sendRequest: createNewTPRequest } = useHttp();
  const { sendRequest: getAllQuestionsList } = useHttp();
  const { sendRequest: getSelectedVendorAddress } = useHttp();
  const { sendRequest: getTPListDetails } = useHttp();
  const { sendRequest: getTPContactInfo } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI} = useHttp();

  const { sendRequest: getStatus} = useHttp();
  const { sendRequest: getAllBUUsersList } = useHttp();
  const { sendRequest: getCriticalityList } = useHttp();
  const { sendRequest: getCategoryList } = useHttp();
  const { sendRequest: getAllBUAssessmentTypeList} = useHttp();
  const { sendRequest: getAllBUFrequencyList} = useHttp();
  const { sendRequest: getAllBURecurrenceList} = useHttp();
  const { sendRequest: getAllClassifications} = useHttp();
 
  const [thirdPartyUsers, setThirdPartyUsers] = useState([{user_id: 0,
    user_name: `<h6>Add New Third Party User +</h6>`}]);

  useEffect(() => {
    getInitialDataHandler();
  }, []);

  const spocDropdownData = [
  {
    value: true,
    label: 'Yes'
  },
  {
    value: false,
    label: 'No'
  }
] 

  // useEffect(() => {
  //   if (departments.length) {
  //     setLoader(false)
  //   }
  // }, [departments])



  const handleDraft = (value) => {
    setSave(true);
    setDraftValue(value);
  };

  const handleSelectSpocDropdown = (e) => {
    if (e) {
      setSpocFlag(true);
    }
    else {
      setSpocFlag(false);
      setAdditionalSpoc({
        additionalSpocData: [
          {
            firstNameAdditional: "",
            lastNameAdditional: "",
            businessDesignationAdditional: "",
            emailAdditional: "",
            phoneNumberAdditional: ""
          }
        ]
      })
    }
  }

  const errorFunction = (errors, touched) => {
    let touchedArr = Object.keys(touched);
    if (touchedArr.length == 31) {
      let keys = Object.keys(errors);

      if (
        keys.includes("status") ||
        keys.includes("requestedBy") ||
        keys.includes("thirdPartyID") ||
        keys.includes("thirdPartyName") ||
        keys.includes("department") ||
        keys.includes("subDepartment") ||
        keys.includes("totalContractValue") ||
        keys.includes("countryOfBusiness")
      ) {
        displayToastMessage("Fill the details in General Information", "error");
      } else if (
        keys.includes("address") ||
        keys.includes("country") ||
        keys.includes("city") ||
        keys.includes("state") ||
        keys.includes("zip") ||
        keys.includes("phonenumber")
      ) {
        displayToastMessage("Fill the details in Corporate Address", "error");
      } else if (
        keys.includes("criticality") ||
        keys.includes("category") ||
        keys.includes("others")
      ) {
        displayToastMessage(
          "Fill the details in Third Party Information",
          "error"
        );
      } else if (
        keys.includes("designation") ||
        keys.includes("firstName") ||
        keys.includes("lastName") ||
        keys.includes("vendorPhoneNumber") ||
        keys.includes("email")
      ) {
        displayToastMessage(
          "Fill the details in Point of Contact Information",
          "error"
        );
      } else if (
        keys.includes("assessment") ||
        keys.includes("frequency") ||
        keys.includes("recurrence") ||
        keys.includes("endAfter") ||
        keys.includes("regulatory")
      ) {
        displayToastMessage(
          "Fill the details in Assessment Requirements",
          "error"
        );
      } else if (keys.includes("InternalContacts")) {
        displayToastMessage("Fill the details in Internal Contacts", "error");
      } else if (keys.includes("questions")) {
        displayToastMessage("Fill the responses in Questionnaire", "error");
      }
    }
  };

  const responseHandler = (result) => {
    if (result.CODE) {
      let temp = [
        {
          vendor_id: 0,
          vendor_name: `<h6>Add New Third Party+</h6>`,
        },
      ];
      result.MSG.forEach((item) => {
        temp.push(item);
      });
      setVendors(temp);
    }
  };

  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
  };

  const responseHandlerBU = (result) => {
    if (result.CODE) {
      setDepartments(result.MSG);
    }
  };

  const responseHandlerSBU = (result) => {
    if (result.CODE) {
      setSubDepart(result.MSG);
    }
  };

  const responseHandlerStatus = (result) => {
    if (result.CODE) {
      setStatus(result.MSG);
    } 
  }

  const responseHandlerBUUsers = (result) => {
    if (result.CODE) {
      setRequestedBy(result.MSG);
    }
  }

  const responseHandlerCriticality = (result) => {
    if (result.CODE) {
      setCriticality(result.MSG);
    }
  }

  const responseHandlerCategory = (result) => {
    if (result.CODE) {
      setCategory(result.MSG);
    }
  }

  const responseHandlerBUAssessmentType = (result) => {
    if (result.CODE) {
      setAssessmentTypes(result.MSG);
    }
  }

  const responseHandlerFrequency = (result) => {
    if (result.CODE) {
      setFrequency(result.MSG);
    }
  }

  const responseHandlerBURecurrence = (result) => {
    if (result.CODE) {
      setRecurrence(result.MSG);
    }
  }

  const responseHandlerClassifications = (result) => {
    if (result.CODE) {
      setClassification(result.MSG);
    }
  }

  let getInitialDataHandler = async() => {
    const orgId=sessionStorage.getItem('orgId');
    await getAllQuestionsList(APIService.getAllQuestionsList(orgId), (result) => {
      if (result.CODE) {
        let data = result.MSG;
        data = data.map((v) => ({ ...v, response: "" }));
        setQuestions(data);
      }
    }, errorHandler)
      await getAllVendorList(APIService.getAllVendorList(), responseHandler, errorHandler)
      await getAllBusinessUnitList(APIService.getAllBusinessUnitList(), responseHandlerBU, errorHandler)
      await getAllSubBusinessUnitList(APIService.getAllSubBusinessUnitList(), responseHandlerSBU, errorHandler)
      await getStatus(APIService.getStatus(), responseHandlerStatus, errorHandler)
      await getAllBUUsersList(APIService.getAllBUUsersList(), responseHandlerBUUsers, errorHandler)
      await getCriticalityList(APIService.getCriticalityList(), responseHandlerCriticality, errorHandler)
      await getCategoryList(APIService.getCategoryList(), responseHandlerCategory, errorHandler)
      await getAllBUAssessmentTypeList(APIService.getAllBUAssessmentTypeList(), responseHandlerBUAssessmentType, errorHandler)
      await getAllBUFrequencyList(APIService.getAllBUFrequencyList(), responseHandlerFrequency, errorHandler)
      await getAllBURecurrenceList(APIService.getAllBURecurrenceList(), responseHandlerBURecurrence, errorHandler)
      await getAllClassifications(APIService.getAllClassifications(), responseHandlerClassifications, errorHandler)
      emailRoleAPI(
        APIService.getEmailsByRoleID(3),
        (result) => {
        if (result.CODE) {
          setEmails(result.MSG);
        } else {
        }
      },
      (err) => {
        displayToastMessage("Something went wrong, Please try again!", "error");
      });
      setLoader(false);
  };

  //Formik Initial Values
  let GeneralInformationInitialValues = {
    status: 1,
    requestedBy: Number(sessionStorage.getItem("userId")),
    thirdPartyID: "",
    thirdPartyName: "",
    department: "",
    subDepartment: "",
    totalContractValue: "",
    countryOfBusiness: [],
    boarding: "",
  };

  let CoporateAddressInitialValues = {
    address: "",
    country: "",
    city: "",
    state: "",
    zip: "",
    phonenumber: "",
  };

  let VendorInformationInitialValues = {
    criticality: "",
    category: "",
    others: "",
  };

  let vendorContactInformationInitialValues = {
    designation: "",
    firstName: "",
    firstNameID: "",
    lastName: "",
    vendorPhoneNumber: "",
    email: "",
  };

  let assessmentInitialValues = {
    assessment: "",
    frequency: null,
    recurrence: null,
    endAfter: null,
    regulatory: "",
  };

  let InternalContactsInitialValues = {
    InternalContacts: [{ username: "", department: "", roleInProject: "" }],
  };

  let QuestionnaireInitialValues = {
    questions: questions,
  };

  //Formik Validation Schemas
  const validationSchema = Yup.object().shape({
    status: Yup.number().required("Please enter Status"),
    requestedBy: Yup.number().required("Please enter Requested By"),
    thirdPartyID: Yup.number().required("Please enter Third Party Name"),
    thirdPartyName: Yup.string().when("thirdPartyID", {
      is: 0,
      then: Yup.string().required("Add a New Vendor Name"),
    }),
    department: Yup.string().required("Please select Department"),
    subDepartment: Yup.string().required("Please enter Sub - Department"),
    boarding: Yup.string().required("Please select boarding"),
    countryOfBusiness: Yup.array()
      .min(1, "Please select at least 1 Country of Business")
      .required("Please select Country of Business"),
    totalContractValue: Yup.number().required(
      "Please enter Total Contract value "
    ),
    address: Yup.string()
      .required("Please enter Address")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    country: Yup.string().required("Please select Country"),
    city: Yup.string()
      .required("Please enter City")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    state: Yup.string()
      .required("Please enter State")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    zip: Yup.string()
      .required("Please enter Zip")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    phonenumber: Yup.number().required("Please enter Phone number"),
    criticality: Yup.string().required("Please select Criticality"),
    category: Yup.string().required("Please select Category"),
    others: Yup.string().when("category", {
      is: 6,
      then: Yup.string().required("Add a New Category Name"),
    }),
    firstNameID: Yup.number().required("Please enter Third Party User"),
    firstName: Yup.string()
      .trim()
      .when("firstNameID", {
        is: 0,
        then: Yup.string().required("Add a New Third Party User"),
      }),
    lastName: Yup.string()
      .trim()
      .required("Please enter Last Name")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    designation: Yup.string()
      .trim()
      .required("Please enter Business Designation")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    vendorPhoneNumber: Yup.number().required("Please enter Phone Number"),
    email: Yup.string().email().trim().required("Please enter Email"),
    assessment: Yup.string().required("Please select Assessment"),
    regulatory: Yup.string()
      .required("Please enter Regulatory/ Standard Requirements")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
    InternalContacts: Yup.array().of(
      Yup.object().shape({
        username: Yup.string().required("Please select User Name"),
        department: Yup.string().required("Please select Department"),
        roleInProject: Yup.string()
          .required("Please enter Role")
          .matches(
            /^[a-zA-Z\d\-_.,&#()\s]+$/,
            "Only alphabets, numbers and some special characters are allowed for this field "
          ),
      })
    ),

    questions: Yup.array().of(
      Yup.object().shape({
        response: Yup.string()
          .nullable()
          .required("Response is required")
          .matches(
            /^[a-zA-Z\d\-_.,&#()\s]+$/,
            "Only alphabets, numbers and some special characters are allowed for this field "
          ),
      })
    ),
  });

  const SaveValidationSchema = Yup.object().shape({
    status: Yup.number().required("Please enter Status"),
    requestedBy: Yup.number().required("Please enter Requested By"),
    thirdPartyID: Yup.number().required("Please enter Third Party Name"),
    thirdPartyName: Yup.string().when("thirdPartyID", {
      is: 0,
      then: Yup.string().required("Add a New Vendor Name"),
    }),
    department: Yup.string().required("Please enter Department"),
    subDepartment: Yup.string().required("Please enter Sub - Department"),
    countryOfBusiness: Yup.array()
      .min(1, "Please select at least 1 Country of Business")
      .required("Please select Country of Business"),
    totalContractValue: Yup.number().required(
      "Please enter Total Contract value "
    ),

    address: Yup.string().matches(
      /^[a-zA-Z\d\-_.,&#()\s]+$/,
      "Only alphabets, numbers and some special characters are allowed for this field "
    ),
    country: Yup.string(),
    city: Yup.string().matches(
      /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
      "Only alphabets and numbers are allowed for this field "
    ),
    state: Yup.string(),
    zip: Yup.string().matches(
      /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
      "Only alphabets and numbers are allowed for this field "
    ),
    phonenumber: Yup.number(),

    criticality: Yup.string(),
    category: Yup.string(),
    others: Yup.string().when("category", {
      is: 6,
      then: Yup.string(),
    }),
    firstNameID: Yup.number().required("Please enter Third Party Name"),
    firstName: Yup.string()
      .when("firstNameID", {
        is: 0,
        then: Yup.string().required("Add a New Vendor Name"),
      })
      .matches(
        /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
        "Only alphabets and numbers are allowed for this field "
      ),
    lastName: Yup.string().matches(
      /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
      "Only alphabets and numbers are allowed for this field "
    ),
    designation: Yup.string().matches(
      /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
      "Only alphabets and numbers are allowed for this field "
    ),
    vendorPhoneNumber: Yup.number(),
    email: Yup.string().email(),
    assessment: Yup.string(),
    regulatory: Yup.string(),

    InternalContacts: Yup.array().of(
      Yup.object().shape({
        username: Yup.string(),
        department: Yup.string(),
        roleInProject: Yup.string().matches(
          /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
          "Only alphabets and numbers are allowed for this field "
        ),
      })
    ),

    questions: Yup.array().of(
      Yup.object().shape({
        response: Yup.string()
          .nullable()
          .required("Response is required")
          .matches(
            /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
            "Only alphabets and numbers are allowed for this field "
          ),
      })
    ),
  });

  const InitialValues = {
    ...GeneralInformationInitialValues,
    ...CoporateAddressInitialValues,
    ...VendorInformationInitialValues,
    ...vendorContactInformationInitialValues,
    ...assessmentInitialValues,
    ...InternalContactsInitialValues,
    ...QuestionnaireInitialValues,
  };

  const handleAccordions = (e) => {
    setActiveAccordions(e);
  };
  const handleReset = () => {
    setActiveAccordions([]);
  };

  const getCriticality = async (ID) => {
    criticality &&
      criticality.map((val, index) => {
        if (val.criticality_id == ID) {
          setCriticalityValue(val.criticality);
        }
      });
  };
  const getAssessment = async (ID) => {
    assessmentTypes &&
      assessmentTypes.map((val, index) => {
        if (val.assessmenttype_id == ID) {
          setAssessmentValue(val.assessment_type);
        }
      });
  };

  const checkBeforeSubmit = (errors, touched) => {
    errorFunction(errors, touched);
  };

  const checkEmptyEmailField = () => {
    let tempResult = false;
    additionalSpoc.additionalSpocData.forEach((item) => {
      if (item.emailAdditional === "" && spocFlag) {
        tempResult = true;
        return;
      }
    })
    return tempResult;
  }

  const checkDuplicateEmail = () => {
    let tempEmail = [];
    additionalSpoc.additionalSpocData.forEach((item) => {
      tempEmail.push(item.emailAdditional);
    })
    let tempEmailSet = new Set(tempEmail);
    if (tempEmailSet.size === additionalSpoc.additionalSpocData.length) {
      return false;
    }
    else return true;
  }

  const handleSubmit = async (values) => {
    let emptyEmail = checkEmptyEmailField();
    let duplicateEmail = checkDuplicateEmail();
    if (!(emptyEmail || duplicateEmail)) {
    setBtnLoader(true);
    let arrayObj = values.InternalContacts;
    var i;
    for (i = 0; i < arrayObj.length; i++) {
      arrayObj[i].paramUserName = arrayObj[i]["username"];
      arrayObj[i].paramDepartment = arrayObj[i]["department"];
      arrayObj[i].paramRoleInProject = arrayObj[i]["roleInProject"];
    }

    let modifiedQuestions = [];

    values.questions.forEach((item) => {
      let obj = {
        paramVendorQuestionID: item.questionID,
        paramResponse: item.response,
      };
      modifiedQuestions.push(obj);
    });

    let tempFirstName = '';
    if (Number(values.firstNameID) !== null && Number(values.firstNameID) !== 0) {
      let filteredData = thirdPartyUsers.filter(item => item.user_id === Number(values.firstNameID))
      tempFirstName = filteredData[0].user_name;
    }
    else {
      tempFirstName = values.firstName.trim();
    }

    let data = {
      paramEmail:sessionStorage.getItem("email"),
      paramRequestedBy: values.requestedBy,
      // paramStatusId: Number(values.status),
      paramVendorId: Number(values.thirdPartyID), //thirdPartyName need to be added.
      paramVendorName: values.thirdPartyName,
      paramVendorDepartmentID: Number(values.department),
      paramVendorSubDepartmentID: Number(values.subDepartment),
      paramTotalContractValue: Number(values.totalContractValue),
      paramCountriesOfBusiness: values.countryOfBusiness.toString(),
      paramCriticality: values.criticality,
      paramCategory: values.category,
      paramRoleId: Number(sessionStorage.getItem("roleId")),
      paramCategoryOthers: values.others, //TODO values.others BE column type need to change as
      paramCorporateAddressAddress: values.address,
      paramCorporateAddressCountry: values.country,
      paramCorporateAddressCity: values.city,
      paramCorporateAddressState: values.state,
      paramCorporateAddressZip: values.zip,
      paramCorporateAddressPhoneNumber: values.phonenumber,
      paramAssessReqRegulatoryStandardRequirements: values.regulatory,
      paramAssessReqAssesmentType: values.assessment,
      paramAssessReqFrequency: values.frequency,
      paramAssessReqRecurrenceMonths: values.recurrence,
      paramAssessReqEndAfter: values.endAfter,
      paramVendorPointOfContactBusinessDesignation: values.designation.trim(),
      paramVendorPointOfContactFirstNameId: Number(values.firstNameID), //thirdPartyUser need to be added.
      paramVendorPointOfContactFirstName: tempFirstName,
      paramVendorPointOfContactLastName: values.lastName.trim(),
      paramVendorPointOfContactEmail: values.email.trim(),
      paramVendorPointOfContactPhone: values.vendorPhoneNumber.trim(),
      paramCreatedBy: Number(sessionStorage.getItem("userId")),
      paramOrgID: sessionStorage.getItem("orgId"),
      paramAdditionalSpoc: spocFlag ? additionalSpoc.additionalSpocData : null,
      paramInternalContacts: arrayObj,
      orgName:sessionStorage.getItem("org_name"),
      paramaction: [
        {
          countryOfBusiness: values.countryOfBusiness.toString(),
          criticality: criticalityValue,
          assessmentType: assessmentValue,
          regulatoryRequirements: values.regulatory,
        },
      ],
      paramQuestionnaire: modifiedQuestions,
      analystEmail1: emails[0]?.email_id,
      analystEmail2: emails[1]?.email_id,
      paramBoarding: values.boarding,
    };
    if (draftValue != "4") {
      data.paramStatusId = values.status;
    } else {
      data.paramStatusId = draftValue;
    }
if(modifiedQuestions.length>0)
  {
    createNewTPRequest(
      APIService.createNewTPRequest(data),
      (result) => {
        let notifData = {
          paramuserid: Number(sessionStorage.getItem("userId")),
          paramreqid: Number(values.thirdPartyID),
          paramcontent: "created New Third Party Request",
          paramnextroleid: 3,
          paramcreatedby: Number(sessionStorage.getItem("roleId")),
          parammsgtype: result.MSG,
        };
        handleNotificationSubmitAPI(
          APIService.handleNotificationSubmit(notifData),
          () => {}
        );
        displayToastMessage("Third Party Request saved successfully", "success");
        props.history.push("/thirdpartyRequestManagement");
      },
      (error) => {
        displayToastMessage(
          "Third Party Account already exist, Please create new account!",
          "error"
        );
      }
    );
  }else{
    displayToastMessage(
      "Please add questionnaire",
      "error"
    );
  }

    setBtnLoader(false);
  }
  else {
    if (emptyEmail === true) {
      displayToastMessage("Please enter at least the email address for all the entries of the spocs", "error");
    }
    else {
      displayToastMessage("All the email address of the additional spocs should be different", "error");
    }
  }
  };

  const expandAllAccordions = () => {
    if (!openedAccordions) {
      setActiveAccordions(["1", "2", "3", "4", "5", "6", "7"]);
    } else {
      setActiveAccordions([]);
    }

    setOpenedAccordions((prev) => !prev);
  };

  const handleClickAddButton = (e) => {
    e.preventDefault();
    let emailFieldCheck = checkEmptyEmailField();
    let duplicateEmail = checkDuplicateEmail();
    if (!(emailFieldCheck || duplicateEmail)) {
    setAdditionalSpoc({
      ...additionalSpoc,
      additionalSpocData: [
        ...additionalSpoc.additionalSpocData,
        {
          firstNameAdditional: "",
          lastNameAdditional: "",
          businessDesignationAdditional: "",
          emailAdditional: "",
          phoneNumberAdditional: ""
        }
      ]
    })
  }
  else {
    if (emailFieldCheck === true) {
      displayToastMessage("Please enter at least the email address for all the previous entries of the spocs", "error");
    }
    else {
      displayToastMessage("All the email address of the additional spocs should be different", "error");
    }
  }
  }

  const handleRemoveButton = (index) => {
    additionalSpoc.additionalSpocData.splice(index - 1, 1);
    setAdditionalSpoc({
      ...additionalSpoc, additionalSpocData: [
        ...additionalSpoc.additionalSpocData
      ]
    })
  }

  const handleChangeFirstNameAdditional = (e, index, item) => {
    setAdditionalSpoc({
      ...additionalSpoc, 
      additionalSpocData: [
        ...additionalSpoc.additionalSpocData.slice(0, index),
        {
          ...item,
          firstNameAdditional: e.target.value
        },
        ...additionalSpoc.additionalSpocData.slice(index + 1)
      ]
    })
  }

  const handleChangeLastNameAdditional = (e, index, item) => {
    setAdditionalSpoc({
      ...additionalSpoc, 
      additionalSpocData: [
        ...additionalSpoc.additionalSpocData.slice(0, index),
        {
          ...item,
          lastNameAdditional: e.target.value
        },
        ...additionalSpoc.additionalSpocData.slice(index + 1)
      ]
    })
  }

  const handleChangeDesignationAdditional = (e, index, item) => {
    setAdditionalSpoc({
      ...additionalSpoc, 
      additionalSpocData: [
        ...additionalSpoc.additionalSpocData.slice(0, index),
        {
          ...item,
          businessDesignationAdditional: e.target.value
        },
        ...additionalSpoc.additionalSpocData.slice(index + 1)
      ]
    })
  }

  const handleChangeEmailAdditional = (e, index, item) => {
    setAdditionalSpoc({
      ...additionalSpoc, 
      additionalSpocData: [
        ...additionalSpoc.additionalSpocData.slice(0, index),
        {
          ...item,
          emailAdditional: e.target.value
        },
        ...additionalSpoc.additionalSpocData.slice(index + 1)
      ]
    })
  }

  const handleChangePhoneAdditional = (e, index, item) => {
    setAdditionalSpoc({
      ...additionalSpoc, 
      additionalSpocData: [
        ...additionalSpoc.additionalSpocData.slice(0, index),
        {
          ...item,
          phoneNumberAdditional: e.target.value
        },
        ...additionalSpoc.additionalSpocData.slice(index + 1)
      ]
    })
  }

  return (
    <div className="user-management-container container-fluid">
      {loader ? (
        <div className="row" id="preloader">
          <div className="col-12 col-lg-12 loader-margin text-center">
            <div className="a-loading a-primary a-m-10" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="row mb-2 font-13">
            <div className="col-md-12">
              <div className="float-end ">
                {" "}
                <span
                  className="pe-2 color-e0 underline l-h-1-9 pointer"
                  onClick={expandAllAccordions}
                >
                  {!openedAccordions ? "Expand All" : "Collapse All"}
                </span>
                {props.ReviewFlag ? (
                  <span
                    className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
                    onClick={props.handleBack}
                  ></span>
                ) : (
                  <span
                    onClick={() => {
                      props.history.push("/thirdpartyRequestManagement");
                    }}
                    className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
                  ></span>
                )}
              </div>
            </div>
          </div>

          <div className="pt-3">
            <Formik
              initialValues={InitialValues}
              onReset={handleReset}
              onSubmit={handleSubmit}
              validationSchema={save ? SaveValidationSchema : validationSchema}
              enableReinitialize
            >
              {(prop) => {
                const {
                  values,
                  touched,
                  errors,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  handleReset,
                  isSubmitting,
                } = prop;

                const getTPContactDetails = async (e) => {
                  if (e !== 0) {
                    getTPContactInfo(
                      APIService.getTPContactInfo(e),
                      (result) => {
                        if (result.CODE) {
                          const data = result.MSG[0];
                          Object.keys(data).map((key) => {
                            handleChange(key)({ target: { value: data[key] } });
                          });
                        }
                      }
                    );
                  } else {
                    handleChange("lastName")({ target: { value: "" } });
                    handleChange("email")({ target: { value: "" } });
                    handleChange("vendorPhoneNumber")({
                      target: { value: "" },
                    });
                    handleChange("designation")({ target: { value: "" } });
                  }
                };
                const vendorAddress = async (e) => {
                  if (e !== 0) {
                    let tempVendor = vendors.filter(vendor => vendor.vendor_id === e);
                    handleChange("thirdPartyName")({ target: {value: tempVendor[0]?.vendor_name}})
                    setSelectFieldsDisabled(true);
                    getTPListDetails(
                      APIService.getTPListDetails(e),
                      (result) => {
                        if (result.CODE) {
                          let temp = [
                            {
                              user_id: 0,
                              user_name: `<h6>Add New Third Party User +</h6>`,
                            },
                          ];
                          result.MSG.forEach((item) => {
                            temp.push(item);
                          });
                          setThirdPartyUsers(temp);
                        }
                      }
                    );
                    getSelectedVendorAddress(
                      APIService.getSelectedVendorAddress({ vendorID: e }),
                      (result) => {
                        if (result.CODE) {
                          const data = result.MSG[0];
                          handleChange("boarding")({ target: { value: parseInt(data.boardingType) } })
                          Object.keys(data).map((key) => {
                            //fixed country issue while adding array in this field
                            if (key !== "countryOfBusiness") {
                              handleChange(key)({
                                target: { value: data[key] },
                              });
                            } else {
                              handleChange(key)({
                                target: { value: [data[key].split(",")][0] },
                              });
                            }
                          });
                        }
                      },
                      errorHandler
                    );
                  } else {
                    setSelectFieldsDisabled(false);
                    handleChange("address")({ target: { value: "" } });
                    handleChange("country")({ target: { value: "" } });
                    handleChange("city")({ target: { value: "" } });
                    handleChange("state")({ target: { value: "" } });
                    handleChange("zip")({ target: { value: "" } });
                    handleChange("phonenumber")({ target: { value: "" } });
                    handleChange("requestedBy")({
                      target: {
                        value: Number(sessionStorage.getItem("userId")),
                      },
                    });
                    handleChange("department")({ target: { value: "" } });
                    handleChange("subDepartment")({ target: { value: "" } });
                    handleChange("boarding")({ target: { value: "" } })
                  }
                };
                return (
                  <form onSubmit={handleSubmit}>
                      {spocFlag ? (
                        <>
                        <Accordion
                      // kind="transparent"
                      onClick={handleAccordions}
                      activeKeys={ActiveAccordions}
                      multiple={true}
                    >
                        <AccordionItem itemKey="1" title="General Information">
                      
                        <GeneralInformation
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          status={status}
                          vendors={vendors}
                          departments={departments}
                          subDepart={subDepart}
                          requestedBy={requestedBy}
                          vendorAddressHandler={vendorAddress}
                          update={false}
                          role={"businessUser"}
                        />
                      
                      </AccordionItem>
     
                      <AccordionItem itemKey="2" title="Corporate Address">
                        <CoporateAddress
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          role={"businessUser"}
                          selectFieldsDisabled={selectFieldsDisabled}
                        />
                      </AccordionItem>
                      <AccordionItem
                        itemKey="3"
                        title="Third Party Information"

                      >
                        <VendorInformation
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          criticality={criticality}
                          category={category}
                          getCriticality={getCriticality}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      <AccordionItem
                        itemKey="4"
                        title="Third Party Point of Contact Information"
                      >
                        <VendorContactInformation
                          values={values}
                          touched={touched}
                          errors={errors}
                          ThirdPartyUserList={thirdPartyUsers}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          getTPContact={getTPContactDetails}
                          role={"businessUser"}
                          spocDropdownData = {spocDropdownData}
                          handleSelectSpocDropdown={handleSelectSpocDropdown}
                          editScreen={false}

                        />
                      </AccordionItem>
                        <AccordionItem
                        itemKey="5"
                        title="Additional Point of Contact Information"
                        >
                          <AddMoreSpocs 
                            role={"businessUser"}
                            additionalSpoc={additionalSpoc}
                            setAdditionalSpoc={setAdditionalSpoc}
                            handleClickAddButton={handleClickAddButton}
                            handleRemoveButton={handleRemoveButton}
                            handleChangeFirstNameAdditional={handleChangeFirstNameAdditional}
                            handleChangeLastNameAdditional={handleChangeLastNameAdditional}
                            handleChangeDesignationAdditional={handleChangeDesignationAdditional}
                            handleChangeEmailAdditional={handleChangeEmailAdditional}
                            handleChangePhoneAdditional={handleChangePhoneAdditional}
                            editScreen={false}

                          /> 
                        </AccordionItem>
                        <AccordionItem
                        itemKey="6"
                        title="Assessment Requirements"
                      >
                        <AssessmentRequirements
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          assessmentTypes={assessmentTypes}
                          frequency={frequency}
                          getAssessment={getAssessment}
                          recurrence={recurrence}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      <AccordionItem itemKey="7" title="Internal Contacts">
                        <InternalContacts
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          departments={departments}
                          requestedBy={requestedBy}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      <AccordionItem itemKey="8" title="Questionnaire">
                        <Questionnaire
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      </Accordion>
                      </>
                      ) : (
                        <>
                        <Accordion
                      // kind="transparent"
                      onClick={handleAccordions}
                      activeKeys={ActiveAccordions}
                      multiple={true}
                    >
                        <AccordionItem itemKey="1" title="General Information">
                        
                        <GeneralInformation
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          status={status}
                          vendors={vendors}
                          departments={departments}
                          subDepart={subDepart}
                          requestedBy={requestedBy}
                          vendorAddressHandler={vendorAddress}
                          update={false}
                          role={"businessUser"}

                        />
     
                      </AccordionItem>
                      <AccordionItem itemKey="2" title="Corporate Address">
                        <CoporateAddress
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          role={"businessUser"}
                          selectFieldsDisabled={selectFieldsDisabled}
                        />
                      </AccordionItem>
                      <AccordionItem
                        itemKey="3"
                        title="Third Party Information"
                      >
                        <VendorInformation
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          criticality={criticality}
                          category={category}
                          getCriticality={getCriticality}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      <AccordionItem
                        itemKey="4"
                        title="Third Party Point of Contact Information"
                      >
                        <VendorContactInformation
                          values={values}
                          touched={touched}
                          errors={errors}
                          ThirdPartyUserList={thirdPartyUsers}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          getTPContact={getTPContactDetails}
                          role={"businessUser"}
                          spocDropdownData = {spocDropdownData}
                          handleSelectSpocDropdown={handleSelectSpocDropdown}
                          editScreen={false}

                        />
                      </AccordionItem>
                        <AccordionItem
                        itemKey="5"
                        title="Assessment Requirements"
                      >
                        <AssessmentRequirements
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          assessmentTypes={assessmentTypes}
                          frequency={frequency}
                          getAssessment={getAssessment}
                          recurrence={recurrence}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      <AccordionItem itemKey="6" title="Internal Contacts">
                        <InternalContacts
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          departments={departments}
                          requestedBy={requestedBy}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      <AccordionItem itemKey="7" title="Segmentation Questionnaire">
                        <Questionnaire
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          role={"businessUser"}

                        />
                      </AccordionItem>
                      </Accordion>
                        </>
                      )}
                    <div className="options-container">
                      <button
                        className="cancel-button me-4"
                        type="reset"
                        onClick={() => {
                          props.history.push("/thirdpartyRequestManagement");
                        }}
                        disabled={btnLoader}
                      >
                        Cancel
                      </button>
                      {props.ReviewFlag ? (
                        <Button
                          type="submit"
                          size="xl"
                          className="save-button m-l-2"
                        >
                          Update
                        </Button>
                      ) : (
                        <div className="row">
                          <div className="col-sm-6">
                            {btnLoader && !save ? (
                              <button
                                class="btn btn-secondary loading-btn"
                                type="button"
                                disabled
                              >
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="pl-1">Loading...</span>
                              </button>
                            ) : (
                              <button
                                size="xl"
                                type="submit"
                                className="save-button"
                                onClick={() => {
                                  setSave(false);
                                  checkBeforeSubmit(
                                    errors,
                                    touched
                                  );
                                }}
                              >
                                Submit
                              </button>
                            )}
                          </div>
                          <div className="col-sm-6">
                            {btnLoader && save ? (
                              <button
                                class="btn btn-secondary loading-btn"
                                type="button"
                                disabled
                              >
                                <span
                                  class="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="pl-1">Loading...</span>
                              </button>
                            ) : (
                              <button
                                size="xl"
                                type="submit"
                                onClick={() => handleDraft("4")}
                                className="save-button"
                                kind="negative"
                              >
                                Save
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>
        </div>
      )}
    </div>
  );
}
export default VendorManagement;
